/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const AddButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.save}
      tooltip={formatMessage({ id: "table.row.add" })}
      css={labellessButtonCss}
      iconName="add"
      dataCy="add-record-button"
      {...props}
    />
  );
};

export default AddButton;
